import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useCallback, useState } from "react";
var useToggleAccordion = function(param) {
    var hasExpandableContent = param.hasExpandableContent, onExpandAccordionItem = param.onExpandAccordionItem;
    var _useState = _sliced_to_array(useState(false), 2), isAccordionOpen = _useState[0], setIsAccordionOpen = _useState[1];
    var toggleIsAccordionOpen = useCallback(function() {
        if (hasExpandableContent) {
            setIsAccordionOpen(function(prevState) {
                if (!prevState) {
                    onExpandAccordionItem === null || onExpandAccordionItem === void 0 ? void 0 : onExpandAccordionItem();
                }
                return !prevState;
            });
        }
    }, [
        onExpandAccordionItem,
        hasExpandableContent
    ]);
    return {
        isAccordionOpen: isAccordionOpen,
        toggleIsAccordionOpen: toggleIsAccordionOpen
    };
};
export default useToggleAccordion;
